module.exports = __webpack_public_path__ + "static/FaktSoftPro-SemiBold.dd14bd25.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/FaktSoftPro-SemiBold.woff
// module id = 495
// module chunks = 114276838955818